import GatewayAxiosClient from '~/store/services/GatewayAxiosClient';
import type { SimulationUpload } from '~/store/simulation/types';

export const uploads = {
  search: {
    queryKey: 'simulation-service/uploads',
    configurationType: 'cached' as const,
    fn: async (partnerId: string): Promise<SimulationUpload[]> => {
      const response = await GatewayAxiosClient.get<SimulationUpload[]>(
        `/shipium-internal-proxy/simulation/${partnerId}/uploads`,
      );
      return response.data;
    },
  },
  validate: async (s3Key: string) => {
    const { data } = await GatewayAxiosClient.post<SimulationUpload>(
      `/shipium-internal-proxy/simulations/uploads/process-shipment-upload`,
      { s3Key },
    );

    return {
      data,
      invalidateQueryKeys: [['simulation-service/uploads']],
    };
  },
  delete: async ({ partnerId, s3Key }: { partnerId: string; s3Key: string }) => {
    const { data } = await GatewayAxiosClient.delete<SimulationUpload>(
      `/shipium-internal-proxy/simulation/${partnerId}/uploads/${s3Key}`,
    );

    return {
      data,
      invalidateQueryKeys: [['simulation-service/uploads'], ['simulation-service/uploads/id', s3Key]],
    };
  },
};
